<div style="position: fixed;  width: 100%; height: 100%; background: #FFF; z-index: 9999999; top: 0;" [class.hide-landing-overlay]="readyToShow" [class.d-none]="readyToChangeZindex"></div>

<div id="home"></div>
<!-- ======= Header ======= -->
<header id="header" class="fixed-top  header-transparent">
  <div class="container">
    <div class="d-flex align-items-center">
      <div class="logo mr-auto position-relative">
        <a href="/">
          <img [src]="customPublicInterface ? '../../../assets/images/logo_portal_medical_custom.png' : '../../../assets/images/logo_portal_medical.png'" alt="Portal Medical"/>
        </a>
        <!-- <h1 class="text-light"><a href="/">Portal Medical</a></h1> -->
        <!-- Uncomment below if you prefer to use an image logo -->
        <!-- <a href="index.html"><img src="assets/landing/img/logo.png" alt="" class="img-fluid"></a>-->
        <span *ngIf="clinicName != ''" class="clinic-name">{{ clinicName }}</span>
        <div *ngIf="account && isMobile" class="user" style="margin-bottom: 10px;">
          <span>Bine ați venit, {{ account.person.lastName + " " + account.person.firstName }}. </span>
          <span (click)="logout()" class="font-weight-semibold logout">Logout</span>
        </div>
      </div>

      <nav class="nav-menu d-none d-lg-block">
        <ul>
          <li class="active"><a href="#home">Acasă</a></li>
          <li><a href="#features">Despre portal</a></li>
          <li><a href="#news">Știri</a></li>
          <li><a href="#faq">Întrebări frecvente</a></li>
          <li><a href="#contact">Contact</a></li>

          <li style="opacity: 1;" class="get-started"><a [href]="account ? '/portal/dashboard/main' : '/authentication/signin'">Accesare portal</a></li>
        </ul>
        <div class="user" *ngIf="account">
          <span>Bine ați venit, {{ account.person.lastName + " " + account.person.firstName }}. </span>
          <span (click)="logout()" class="font-weight-semibold logout">Logout</span>
        </div>
      </nav><!-- .nav-menu -->
    </div>
  </div>
</header><!-- End Header -->